import React from 'react';
import type { ListWithIcon as ListWithIconType } from '../../graphql/generated/schema';
import type { IconType } from '../../components';
import { Icon } from '../../components';
import styles from './styles.module.scss';
import colors from '../../styles/colors/index.module.scss';
import { constructClassName } from '../../utils/constructClassName';

export const ListWithIcon: React.FC<ListWithIconType> = ({
  items,
  isHorizontal,
}) => (
  <ul
    className={constructClassName([
      styles.list,
      Boolean(isHorizontal) && styles.horizontal,
    ])}
  >
    {items?.map((item) => (
      <li
        key={item.id}
        className={styles.item}
      >
        <Icon
          icon={(item.icon || 'xClassicRegular') as IconType}
          fill={item.iconColor === 'secondary' ? colors.secondary : colors.primary}
          size={24}
        />
        {item.text}
      </li>
    ))}
  </ul>
);
